import { render, staticRenderFns } from "./lms-taf.vue?vue&type=template&id=2514c0c0&"
import script from "./lms-taf.vue?vue&type=script&lang=js&"
export * from "./lms-taf.vue?vue&type=script&lang=js&"
import style0 from "./lms-taf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports